import { Box, List, ListItem } from '@material-ui/core';
import { Dispatch, SetStateAction } from 'react';

import { CheckResult } from '@/components/shared/components/CheckResult/CheckResult';
import { Font } from '@/components/shared/components/Font';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';

import { RiskAssessmentType } from '../types/RiskAssessmentType';
import { Result } from './AssessmentResult';

interface AssessmentFailureReasonsDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  result: Result;
  type: RiskAssessmentType;
}

export const AssessmentFailureReasonsDialog = ({
  opened,
  setOpened,
  result,
  type,
}: AssessmentFailureReasonsDialogProps) => {
  return (
    <NemuruDialog opened={opened} setOpened={setOpened}>
      <Box mb={5}>
        <Font variant={'h3'} color={'title'}>
          <Text tId={'ASSESSMENT_FAILURE_REASONS'} />
        </Font>
      </Box>
      <Box display={'flex'} flexDirection={'column'}>
        <Font variant={'body1'} color={'textPrimary'}>
          <Text tId={type} />
          <Text tId={'RISK_ASSESSMENT_FAILED_DUE_TO_THE_FOLLOWING_REASONS'} />
        </Font>
        {result.reasons.length > 0 ? (
          <List style={{ paddingTop: '24px' }}>
            {result.reasons.map((reason, key) => (
              <ListItem>
                <CheckResult key={key} check={{ passed: false, description: reason }} />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box mt={3}>
            <PendingDataWarning type={PendingDataType.NO_REASONS_GIVEN} />
          </Box>
        )}
      </Box>
    </NemuruDialog>
  );
};
